module.exports = __webpack_public_path__ + "img/geboortekaart-op-maat-Jakob-jongen-foliedruk-afgeronde-hoeken-aquarel-drukwerk-2.4cb9d8d4.jpg";